export default __webpack_public_path__ + "c66118a7a6752ef4e94927bbf66bf848.jpeg";